export enum LoaderName {
  GALAXY = 'GALAXY',
}
